<template>
  <v-container>
    <v-img
        class="logoCompanyWidget"
        v-if="vidgetOptions!=undefined&&vidgetOptions.logoSrc!=''"
        :src="vidgetOptions.logoSrc"
      />
    <v-stepper 
      v-model="currStep"
    >
      <v-stepper-header>
        <template v-for="(step, keyStep) in steps">
        <v-stepper-step 
                :color="vidgetOptions.colorField.hex"
                :editable="punctEditable(step.value)"
                :key="'stepTitle'+keyStep"
                :complete="currStep > keyStep+1" 
                :step="keyStep+1">{{step.title}}</v-stepper-step>  
        <v-divider 
            v-if="keyStep!=steps.length-1"
            :key="'stepLine'+keyStep"
        ></v-divider>
        </template>
      </v-stepper-header>

      <v-progress-linear
          :active="localLoading"
          indeterminate
          :color="mainColor"
        ></v-progress-linear>
  
      <v-stepper-items>
        <v-stepper-content v-for="(step, keyStep) in steps" :step="keyStep+1" :key="'stepСontent'+keyStep">
          
          <v-card
            class="mb-12"
            v-if="step.value=='setFilial'"
          >
          <stepSetFilial            
            :vidgetOptions="vidgetOptions"
            :currStep.sync="currStep"
            :currentFilial.sync="currentFilial"
            :viewFilials="viewFilials"
          />
          </v-card>
  

          <stepSetNapravl
            v-if="step.value=='setNapravl'"
            :vidgetOptions="vidgetOptions"
            :currStep.sync="currStep"
            :currNapr.sync="currNapr"
            :currentFilial="currentFilial"
            :localLoading.sync="localLoading"
            :steps="steps"
            :formToken="formToken"
            :appOptions="appOptions"
            :dateResourse.sync="dateResourse"
            :longTime.sync="longTime"
            :arrProduct.sync="arrProduct"
            :timezoneOffset.sync="timezoneOffset"
          />

          <stepPersonalData
            v-if="step.value=='inputPersonalData'"
            :vidgetOptions="vidgetOptions"
            :currStep.sync="currStep"
            :currNapr="currNapr"
            :currentFilial="currentFilial"
            :localLoading.sync="localLoading"
            :steps="steps"
            :formToken="formToken"
            :appOptions="appOptions"
            :dateResourse="dateResourse"
            :longTime="longTime"
            :utmObject="utmObject"
            :arrProduct="arrProduct"
            @startNew="startNew"
            :timezoneOffset="timezoneOffset"
          />
          
        </v-stepper-content>

      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
  export default {
    name: 'stepperForm',

    methods:{
      startNew:function(){
        this.currStep=1;
        this.currNapr=undefined;
        if (this.viewFilials.length>1){
          this.currentFilial=undefined;
        }
        this.dateResourse=undefined;
        this.longTime=Number(this.appOptions.settings.sizeGrid)?Number(this.appOptions.settings.sizeGrid):15;
      },
      punctEditable:function(value){
        if (value=='setFilial'){
          return true;
        }

        if ((this.steps.length==3&&value=='setNapravl'&&this.currentFilial!=undefined)||(this.steps.length==2&&value=='setNapravl')){
          return true;
        }

        if ((this.steps.length==3&&value=='inputPersonalData'&&this.currentFilial!=undefined&&this.dateResourse!=undefined)||(this.steps.length==2&&value=='inputPersonalData'&&this.dateResourse!=undefined)){
          return true;
        }

        return false;
      }
    },

    components:{
      stepSetFilial:()=>import('./stepSetFilial'), 
      stepSetNapravl:()=>import('./stepSetNapravl'),
      stepPersonalData:()=>import('./stepPersonalData')
    },

    mounted:function(){
      if (this.viewFilials.length==1){
          this.currentFilial=this.viewFilials[0];
      }
    },

    props:{
      vidgetOptions:undefined,
      formToken:undefined,
      appOptions:undefined,
      utmObject:undefined,
    },

    computed:{
      steps:function(){
        var result=[];
        if (this.viewFilials.length>1){
          result.push({title:this.$t("onlineForm.stepper.setFilial"), value:"setFilial"});
        }    
        result.push({title:this.$t("onlineForm.stepper.setNapravl"), value:"setNapravl"});  
        result.push({title:this.$t("onlineForm.stepper.inputPersonalData"), value:"inputPersonalData"});
        return result;
      },      
      viewFilials:function(){
        let result=[];
        for (let idx in this.vidgetOptions.filials){
          if (this.vidgetOptions.filials[idx].id){
            result.push(this.vidgetOptions.filials[idx])
          }
        }
        return result;
      },
      mainColor:function(){
        if (this.vidgetOptions.colorField!=undefined&&this.vidgetOptions.colorField.hex!=undefined){
         return this.vidgetOptions.colorField.hex;
        }
        else{
          return '#000';
        }
      }
    },

    watch:{
      currentFilial:function(){
        this.dateResourse=undefined;
      },
      viewFilials:function(){
        if (this.viewFilials.length==1){
          this.currentFilial=this.viewFilials[0];
        }
      }
    },

    data: () => ({
      localLoading:false,
      currStep:1,
      currNapr:undefined,
      currentFilial:undefined,    
      dateResourse:undefined,  
      arrProduct:undefined,
      longTime:0,
      timezoneOffset:0,
    }),
  }
</script>

<style>
  .logoCompanyWidget{
    max-height: 150px;
  }

  .logoCompanyWidget .v-image__image.v-image__image--cover{
    background-size: contain;
  }
</style>
